import { ROUTES, TITLES, PROD, DEV, STAGE } from 'consts';

export const ANALYTICS_MENU = {
  label: TITLES[ROUTES.ANALYTICS.ROOT],
  key: ROUTES.ANALYTICS.ROOT,
  environment: [DEV, STAGE, PROD],
  children: [
    {
      key: ROUTES.ANALYTICS.TRANSFER_TO_SETTLEMENT,
      label: TITLES[ROUTES.ANALYTICS.TRANSFER_TO_SETTLEMENT],
      environment: [DEV, STAGE, PROD],
    },
    // {
    //   key: ROUTES.ANALYTICS.CONTRACTOR,
    //   label: TITLES[ROUTES.ANALYTICS.CONTRACTOR],
    //   environment: [DEV, STAGE, PROD],
    // },
    {
      key: ROUTES.ANALYTICS.RATING,
      label: TITLES[ROUTES.ANALYTICS.RATING],
      environment: [DEV, STAGE, PROD],
    },
    {
      key: ROUTES.ANALYTICS.REPORTING_OVP,
      label: TITLES[ROUTES.ANALYTICS.REPORTING_OVP],
      environment: [DEV, STAGE, PROD],
    },
    {
      key: ROUTES.ANALYTICS.APARTMENT_STATUS,
      label: TITLES[ROUTES.ANALYTICS.APARTMENT_STATUS],
      environment: [DEV, STAGE, PROD],
    },
  ],
};
